"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServVer = void 0;
const base_1 = require("./base");
/**
 * Verizon
 */
class AnServVer extends base_1.AnServBase {
    static isLoaded() {
        return (window.dotq !== undefined);
    }
    static sendCustEventP(pixelId, projectId, props) {
        dotq.push({
            projectId: projectId,
            properties: {
                pixelId: pixelId,
                qstrings: props,
            }
        });
        this.logEvent({ cmd: "push", eventProps: props });
        return true;
    }
}
exports.AnServVer = AnServVer;
AnServVer.serviceName = "Verizon";
